import { ActionDefinition, ActionTypes, ActionableDefinitions, Loader, Table, TableRow, icons } from '@lifebit-ai/lds'
import { ResultsState } from 'enums'
import React from 'react'

import { RetryButton } from 'modules/requests/ExportAndAccessRequestsTable/RequestsTable.styles'
import { isRetrySupported } from 'modules/requests/utils'
import type { Result } from 'services/results/types'

export enum RowOverlayActionTypes {
  Retry = 'retry',
  AssignTo = 'assignTo',
  Unassign = 'unassign'
}

export const getTableRowActions = (row: TableRow<Result>, isRetrying: boolean) => {
  const dropdownActions: ActionDefinition[] = []
  const isResultFailed = row.original.status === ResultsState.Failed

  if (isResultFailed && isRetrySupported(row.original)) {
    dropdownActions.push({
      type: ActionTypes.Button,
      icon: (
        <RetryButton $disabled={isRetrying}>{isRetrying ? <Loader text={false} /> : <icons.RedoSmall />}</RetryButton>
      ),
      name: 'Retry',
      id: RowOverlayActionTypes.Retry
    })
  }

  if (row.original.status === ResultsState.PendingVerification) {
    if (row.original.assignedTo) {
      dropdownActions.push({
        type: ActionTypes.Button,
        name: 'Unassign',
        id: RowOverlayActionTypes.Unassign
      })
    } else {
      dropdownActions.push({
        type: ActionTypes.Button,
        name: 'Assign to',
        id: RowOverlayActionTypes.AssignTo
      })
    }
  }

  return {
    visibleActions: [],
    dropdownActions
  }
}

interface RowHoverOverlayProps {
  row: TableRow<Result>
  onClickRetry: (row: TableRow<Result>) => void
  onAssignTo: (resultId: string) => void
  onUnassignFrom: (resultId: string) => void
  isRetrying: boolean
}

const RowHoverOverlay: React.FC<RowHoverOverlayProps> = ({
  row,
  onClickRetry,
  onAssignTo,
  onUnassignFrom,
  isRetrying
}) => {
  const handleOnActionClicked = (row: TableRow<Result>, action: ActionableDefinitions) => {
    switch (action.id) {
      case RowOverlayActionTypes.Retry:
        onClickRetry(row)
        break
      case RowOverlayActionTypes.AssignTo:
        onAssignTo(row.original._id)
        break
      case RowOverlayActionTypes.Unassign:
        onUnassignFrom(row.original._id)
        break
      default:
        break
    }
  }

  return (
    <Table.RowHoverOverlay
      row={row}
      isSelected={false}
      onActionClicked={handleOnActionClicked}
      actions={getTableRowActions(row, isRetrying)}
    />
  )
}

export default RowHoverOverlay
